var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "page" } }, [
        _vm.open
          ? _c(
              "div",
              {
                staticClass: "modal",
                staticStyle: { display: "block" },
                attrs: { tabindex: "-1", role: "dialog" },
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "modal-dialog",
                    attrs: { role: "document" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "modal-content" }, [
                      _c("div", { staticClass: "modal-header" }, [
                        _vm.title
                          ? _c("h5", { staticClass: "modal-title" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.title) +
                                  "\n                    "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "close",
                            attrs: {
                              type: "button",
                              "data-dismiss": "modal",
                              "aria-label": "Close"
                            },
                            on: {
                              click: function($event) {
                                return _vm.$emit("close")
                              }
                            }
                          },
                          [
                            _c("span", { attrs: { "aria-hidden": "true" } }, [
                              _vm._v("×")
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.$slots.default
                        ? _c(
                            "div",
                            { staticClass: "modal-body" },
                            [_vm._t("default")],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$slots.footer
                        ? _c(
                            "div",
                            { staticClass: "modal-footer" },
                            [_vm._t("footer")],
                            2
                          )
                        : _vm._e()
                    ])
                  ]
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.open ? _c("div", { staticClass: "modal-backdrop" }) : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4acc3f58", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4acc3f58","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../default-js/js/components/common/Modal.vue
// module id = 249
// module chunks = 17